{
    "confirm": {
        "confirmToDeleteMediaAndRemoveFromProjects": "プロジェクトから消去・削除する | プロジェクトから消去・削除する",
        "unsavedChanges": "保存されていない変更!",
        "areYouSureYouWantToRemovePage": "'{pageName}'を削除する。",
        "deleteStyle": "スタイルを削除しますか?",
        "deleteMedia": "メディアを削除しますか?",
        "deleteMediaImplications": "プロジェクトから消去・削除しますか？",
        "deletePlayer": "プレイヤーを削除しますか?",
        "deletePlayerImplications": "この操作により、このプレイヤーがARYAアカウントから消去され、スケジューリングを含む全ての設定が削除されます。",
        "permanentlyDeleteTheUserAccount": "アカウントを削除する。",
        "removeTemplate": "テンプレートを消去する",
        "removeTemplateDesc": "このスタイルからこのテンプレートを消去しますか？",
        "removeTheMediaFromTheSchedule": "スケジュールを削除する。",
        "mediaNamesIsInUploadStateAndWillPermanentlyDelete": "メディアを削除する。",
        "mediaUsedInProject": "プロジェクトで使用されているメディア | プロジェクトで使用されているメディア",
        "confirmPassword": "パスワードを確認する",
        "changeEmail": "メールアドレスを変更する",
        "deleteOrder": "注文を削除する",
        "deleteTag": "タグを削除しますか？",
        "deletePopId": "PoP IDを削除しますか？",
        "deleteUser": "ユーザーを削除しますか？",
        "deleteAccount": "アカウントを削除しますか？",
        "leaveAccount": "アカウントを退会しますか？",
        "deleteCanvasResolution": "キャンバス解像度を削除しますか？",
        "downloadLicense": "ライセンスをダウンロードしますか？",
        "cancelOrder": "注文をキャンセルしますか？",
        "removeAccessFromArya": "ARYAからのアクセスを削除しますか？",
        "deleteTemplate": "テンプレートを削除しますか？"
    },
    "signinup": {
        "new": "{productNameShort}の使用は初めてですか？",
        "newUser": "新しいユーザー"
    },
    "label": {
        "aryaAccountID": "Arya アカウントID",
        "accountId": "アカウントID",
        "admin": "管理者",
        "addPlayer": "プレイヤーを追加する",
        "assignCodeHasAlreadyBeenAssignedInAnotherAccountErrorMessage": "{code}コードは、既に他のアカウントに適用されています。",
        "assignCodeHasAlreadyBeenAssignedErrorMessage": "{code}コードが適用されました。",
        "account": "アカウント | アカウント",
        "accountInfo": "アカウント情報",
        "accountInformation": "アカウント情報",
        "accountName": "アカウント名",
        "accountPlan": "アカウントプラン",
        "accountCorrespondent": "アカウントコレスポンデント",
        "accountIsDeleted": "アカウントが削除されました",
        "activate": "アクティブにする",
        "address": "アドレス",
        "alert": "アラート",
        "amount": "金額",
        "apply": "適用する",
        "assign": "割り当て | 割り当て",
        "audio": "オーディオ",
        "auto": "自動",
        "basic": "ベーシック",
        "bannerText1": "定期メンテナンス",
        "bannerText2": "{date}の{time}に、約{approximateHours}時間の定期メンテナンスを実施します。ご迷惑をおかけすることをお詫びいたします。",
        "bannerText3": "メンテナンス中は{productName} コンテンツの変更はできませんが、コンテンツの表示は可能です。",
        "billing": "お支払い",
        "billingDetails": "お支払い明細",
        "buy": "購入する",
        "comment": "コメントする",
        "companyInformation": "企業情報",
        "contentNotSupported": "サポートされていないコンテンツです、詳細についてはこちらをクリックしてください",
        "copy": "コピー | コピー",
        "configPending": "Configファイルのペンディング",
        "configError": "Configファイルのエラー",
        "credentials": "識別情報",
        "credentialsNotValid": "識別情報が有効ではありません",
        "createStyle": "スタイルを作成する",
        "createUserExistErrorMessage": "{email}は既にこのアカウントのメンバーになっています。",
        "createUserLimitReached": "ユーザーの人数が上限に達しました",
        "creditCard": "クレジットカード",
        "download": "ダウンロードする",
        "extended": "延長されました",
        "expirationDate": "有効期限",
        "expires": "有効期限を超過しています",
        "keyboardShortcuts": "キーボードのショートカット",
        "language": "言語",
        "learnMore": "詳しく見る",
        "leaveAccount": "アカウントから退出する",
        "leaveAccountWithOnlyOneUserMessage": "アカウントにはあなた以外のユーザーがいないため、退出することができません。",
        "leaveAccountTheOnlyAdminInTheAccountMessage": "アカウントにはあなた以外の管理者がいないため、退出することができません。",
        "leaveAccountImplicationsCommonMessage": "この操作により、アカウントからあなたが削除されます。",
        "license": "ライセンス",
        "limited": "制限されています",
        "location": "位置",
        "login": "ログイン",
        "loginError": "問題が発生しました、現在サインインができません。時間をおいて再度試すか、管理者にお問い合わせください",
        "loginWith": "次でログイン",
        "loginString2": "コンテンツをまとめて画面に表示する。無料。",
        "loginString3": "「シンプル」と、デジタルサイネージの出会い。",
        "loginString4": "機能セットをシームレスに注文して有効化",
        "loginOKStringTitle2": "「シンプル」と、スマートシンクの融合。",
        "loginOKStringDesc1": "カスタマイズしよう。スケジュールを組もう。優先順位をつけよう。",
        "loginOKStringDesc2": "タグ付けしよう。スマートシンクしよう。必要であればアラートしよう。",
        "loginOKString4": "次に進もう。素早くプレイヤーの設定をしよう。",
        "loginOKString5": "必要なものは、プレイヤーのシリアル番号だけです。",
        "loginOKQuotaWarnMain": "無料ストレージは{percentage}%使用されています。 ",
        "loginOKQuotaWarnSub": "{plan}にアップグレードすると、制限なしでカスタマイズ可能なテンプレートとアラート、ユーザー1人当たり10GBのストレージ、10ユーザー、タグとスマートタグシンク、その他様々な機能が利用可能です。",
        "loginOKQuotaReachedMain": "無料ストレージは{percentage}%使用されています。",
        "loginOKQuotaReachedSub": "{plan}にアップグレードすると、制限なしでカスタマイズ可能なテンプレートとアラート、ユーザー1人当たり10GBのストレージ、10ユーザー、タグとスマートタグシンク、その他様々な機能が利用可能です。",
        "loginOKQuotaExcededMain": "無料ストレージの上限を超えました。",
        "loginOKQuotaExcededSub": "{plan}にアップグレードすると、制限なしでカスタマイズ可能なテンプレートとアラート、ユーザー1人当たり10GBのストレージ、10ユーザー、タグとスマートタグシンク、その他様々な機能が利用可能です。",
        "logoutOKStringTitle1": "現在サインアウトされた状態です",
        "logoutOKStringDesc1": "下のボタンをクリックして、再度サインインしてください。",
        "notice": "注意",
        "playerSetupString1": "プロジェクトを作ろう。",
        "playerSetupString2": "とても簡単。素早くできます。",
        "playerSetupString3": "",
        "payments": "お支払い",
        "pageNotFound": "申し訳ありません、ページが存在しません",
        "plan": "プラン | プラン",
        "popIdentifier": "PoP識別子",
        "postalCode": "郵便番号",
        "purchasePlanUpgradeSuccessMain": "{plan}へようこそ",
        "purchasePlanDowngradeSuccessMain": "アカウントが{planName}へダウングレードされました",
        "loggedOffInFewSeconds": "あと数秒でログオフします",
        "termsOfServiceString1": "サービス規約",
        "termsOfServiceString2": "最終更新日：2019年1月9日",
        "termsOfServiceString3": "以下の文書をダウンロードし、お読みください",
        "termsOfServiceString4": "サービス規約",
        "termsOfServiceString5": "プライバシーポリシー",
        "termsOfServiceString6": "続けるには「承認する」を選択してください。",
        "accept": "承認する",
        "all": "全て",
        "allPlayers": "全てのプレイヤー",
        "add": "追加する",
        "setPassword": "確定する",
        "support": "サポート",
        "cancel": "キャンセルする",
        "canvasSize": "キャンバスのサイズ：{size}ピクセル",
        "canvasExistsError": "このサイズのキャンバスが既に存在します",
        "cardType": "カードの種類",
        "cardNumber": "カード番号",
        "change": "変更する",
        "clickToEdit": "クリックして編集する",
        "city": "都市",
        "color": "カラー | カラー",
        "company": "企業",
        "companyName": "企業名",
        "confirm": "確定する",
        "confirmation": "確定",
        "warning": "警告",
        "codeIsRequired": "確認コードが必要です",
        "code": "コード",
        "contact": "お問い合わせ",
        "country": "国",
        "create": "作成する",
        "checkThePlayer": "インターネットに接続する。Powerに接続する。",
        "checkDetails": "詳細を確認する",
        "chooseHorizontalOrVerticalScreenOrientations": "画面の向きを選択する",
        "continue": "続ける",
        "conctactSystemAdmin": "システム管理者にお問い合わせください。",
        "custom": "カスタマイズする",
        "customerInfo": "カスタマー情報",
        "date": "日付",
        "dropFilesHere": "ここにファイルをドロップしてください",
        "deactivate": "非アクティブ化する",
        "default": "デフォルト",
        "delete": "削除する",
        "deleteAccount": "アカウントを削除する",
        "deleteUser": "ユーザーを削除する",
        "deleteOnAllPlayers": "全てのプレイヤーに対して削除する",
        "deleteFromSchedule": "スケジュールから削除する",
        "demoVersion": "デモバージョン",
        "disable": "使用不可能にする",
        "disabled": "使用不可能になりました",
        "distributor": "ディストリビューター",
        "downgradeAccount": "アカウントをダウングレードする",
        "downgradeTo": "{plan}にダウングレードする",
        "duplicate": "コピーする",
        "duplicateFile": "重複するファイル",
        "duplicateInSchedule": "スケジュールにコピーする",
        "duration": "期間",
        "adsDuration": "広告時間",
        "error": "エラー",
        "email": "メールアドレス",
        "emailAlreadyExists": "新しいEメールアドレスは既に他のユーザーが使用しています、他のメールアドレスを使用してください。",
        "enable": "使用可能にする",
        "enabled": "使用可能になりました",
        "endDate": "終了する",
        "endTime": "終了する",
        "end": "終了する",
        "edit": "編集",
        "editProject": "プロジェクトを編集する",
        "feedbackForm": "フィードバックを送信する",
        "firstName": "名",
        "firmwareUpdate": "ファームウェアをアップデートする",
        "failed": "サポートセンターにお問い合わせ",
        "file": "ファイル | ファイル",
        "forgotPassword": "パスワードを覚えていません",
        "formatNotSupported": "'{format}'ファイルはサポートされていません",
        "firmware": "ファームウェア",
        "freeVersion": "無料バージョン",
        "freeVersionNA": "バージョン",
        "get": "入手する",
        "getCode": "Configファイルを入手する",
        "getConfig": "Configファイルを入手する",
        "generateNewAPIKey": "新しいAPIキーを作成する",
        "generateUserAPIKeyWarningMessage": "これにより以前のAPIキーは無効となり、これまでのAPI接続は全て新しいAPIキーで使用できるよう再設定を行う必要があります。",
        "goBack": "元に戻る",
        "goToLogin": "ログインへ進む",
        "helpCenter": "ヘルプセンター",
        "horizontalView": "横向き",
        "image": "画像 | 画像",
        "implications": "影響",
        "implicationsDeleteTag": "この操作により、このタグが全ての{deleteFrom}から削除されますユーザーとして使用できる内容とスケジュールに影響が及ぶ可能性があります。",
        "implicationsDeleteLedTag": "この操作により、このタグが全てのプレイヤーから削除されます。この解像度のコンテンツが再度公開される場合、このタグが付けられていたプレイヤーは全て再設定を行う必要があります。",
        "implicationsDeletePopId": "この操作により、PoP IDが使用されていた全ての場所から削除されます。",
        "importantToNote": "重要事項",
        "logo": "ロゴ",
        "userProfile": "ユーザープロフィール",
        "userSignOut": "サインアウト",
        "userNotConfirmed": "ユーザーが確認されていません",
        "userNotFound": "ユーザーが存在しません。このアカウントが存在することを確認してください",
        "userManagement": "ユーザー管理",
        "id": "id",
        "incorrectUsername": "Eメールに誤りがあります",
        "incorrectPassword": "パスワードに誤りがあります",
        "installedOrCapacity": "インストール済み / 容量",
        "installed": "インストール済み",
        "installedOrCapacityUnlimitedMaxValue": "制限なしのプレイヤー",
        "invalidEmail": "無効のメールアドレスです",
        "invalidPassword": "無効のパスワードです",
        "invalidUserdata": "サポートセンターにお問い合わせ",
        "invalidSerialNumber": "無効のシリアル番号です",
        "invalidDSOSTypeAmount": "無効な数値です、正しい数字を入力してください",
        "invalidResolution": "無効の解像度です",
        "invoice": "請求書 | 請求書",
        "inviteUser": "ユーザーを招待する",
        "requiredDeviceName": "名前が必要です",
        "regular": "標準",
        "resetPassword": "パスワードをリセットする",
        "loading": "ロード中です…",
        "lastName": "姓",
        "lastLogin": "最後にログインした日",
        "modify": "修正する",
        "monitoring": "モニタリング",
        "newPassword": "新しいパスワード",
        "newPasswordRequiredWarning": "パスワードを設定してください",
        "confirmNewPassword": "新しいパスワードを確定する",
        "new": "新",
        "newCanvas": "新しいキャンバス",
        "newProject": "新しいプロジェクト",
        "newEmail": "新しいメールアドレス",
        "newResolution": "新しい解像度",
        "name": "名前",
        "naText": "設定なし",
        "next": "次へ",
        "nextRenewalDate": "次の更新日 {renewalDate}",
        "noVideoAvailable": "利用可能な動画はありません",
        "noEmailProvided": "メールアドレスが提供されていません",
        "none": "なし",
        "noSearchResults": "結果なし",
        "noPermissionToAccessThePage": "アクセスが拒否されました",
        "noPlayersInstalled": "プレイヤーがインストールされていません",
        "noPlayerGroupsAvailable": "プレイヤーグループが存在しません",
        "notConfigured": "設定が必要です",
        "nameYourPlayerEGReception": "プレイヤーに名前を付けてください（例：レセプション）",
        "ok": "はい",
        "or": "または",
        "orders": "注文",
        "order": "注文 | 注文",
        "offline": "オフライン",
        "online": "オンライン",
        "options": "オプション",
        "page": "ページ",
        "player": "プレイヤー | プレイヤー",
        "playerName": "プレイヤー名",
        "playerModel": "プレイヤーモデル",
        "playerGroups": "プレイヤーグループ",
        "pleaseEnterACity": "都市を入力する",
        "pin": "PIN",
        "pinShownOnYourScreen": "画面にPINが表示されています",
        "playTime": "プレイの時間です",
        "PleaseTryAgainOrHeadBackToTheHomepage": "再度試すか、ホームへ戻ってください",
        "playerIsNotConnectedToTheCloud": "無効のシリアル番号です",
        "pleaseTryAgain": "再度試す",
        "pleaseEnterThePin": "PINが必要です",
        "pleaseEnterValidPin": "画面に表示されている4桁または6桁の番号を入力してください",
        "pinMustBeFourDigitNumber": "PINは4桁または6桁です",
        "pinMustBeAtleastOneThousand": "PINは少なくとも1000以上である必要があります",
        "pleaseCheckYourEmailForVerificationCode": "メールアドレスに確認コードが送信されました",
        "password": "パスワード",
        "passwordDidNotMatch": "パスワードが一致しません",
        "passwordCannotBeReset": "パスワードのリセットができません",
        "passwordHasBeenChanged": "パスワードが変更されました",
        "passwordAttemptLimitExceeded": "ログイン試行の上限を超えました、時間をおいて再度試してください",
        "passwordPolicyRequirementText": "パスワードは8文字以上で、大文字、小文字、数字、特殊文字を使用する必要があります",
        "price": "価格",
        "priceSlashMonth": "価格/1か月",
        "priority": "プライオリティ",
        "privacy": "プライバシー",
        "project": "プロジェクト | プロジェクト",
        "projectName": "プロジェクト名",
        "profile": "プロフィール",
        "proofOfPlay": "プレイ証明書",
        "preview": "プレビュー",
        "previewUnavailable": "プレイビューが利用できません",
        "proceed": "次に進む ",
        "publishTo": "公開する",
        "releaseNotes": "リリースノート",
        "remove": "消去する",
        "removeUserFromAccount": "アカウントからユーザーを消去する",
        "replace": "変更する",
        "reporting": "報告",
        "reset": "リセットする",
        "restart": "リスタートする",
        "resolution": "解像度",
        "reactivate": "再度アクティブにする",
        "resetPasswordDescription": "確認コードを送信するメールアドレスを入力してください",
        "resetPasswordCodeSent": "メールアドレスに確認コードが送信されました",
        "resetPasswordCodeSentIfAccountExist": "アカウントが存在する場合",
        "requiredAccountName": "アカウント名が必要です",
        "requiredEmail": "メールアドレスが必要です",
        "requiredCountry": "国名が必要です",
        "requiredPassword": "パスワードが必要です",
        "requiredConfirmPassword": "必要なパスワードを確定してください",
        "requiredFirstName": "名が必要です",
        "requiredLastName": "姓が必要です",
        "requiredName": "名前が必要です",
        "requiredUsername": "メールアドレスが必要です",
        "requiredVerificationCode": "確認コードが必要です",
        "requiredSerialNumber": "シリアル番号が必要です",
        "requiredCity": "都市名が必要です",
        "requiredState": "州名が必要です",
        "requiredZipOrPostalCode": "郵便番号が必要です",
        "requiredStreetAndNumber": "市町村以下の住所と番地が必要です",
        "requiredCompanyName": "企業名が必要です",
        "requiredDataStorageRegion": "データストレージ地域が必要です",
        "invalidDataStorageRegion": "無効なデータストレージ地域",
        "review": "見直す",
        "signOut": "サインアウトする",
        "search": "検索する",
        "addressSearchPlaceholder": "住所を入力してプレイヤーを探してください",
        "searching": "検索中",
        "status": "ステータス",
        "save": "保存する",
        "reconfigure": "セットアップを再スタートする",
        "saveAs": "名前をつけて保存する",
        "saveChanges": "変更を保存する",
        "savedStyles": "保存済みのスタイル",
        "schedule": "スケジュール",
        "scheduledToTag": "タグにスケジュールする",
        "screen": "画面",
        "screenOn": "画面",
        "screenOrientation": "画面の向き",
        "security": "セキュリティ",
        "sendCode": "コードを送信",
        "sendEmail": "送信する",
        "sendInvitation": "招待を送信する",
        "sendTo": "送信する",
        "serial": "シリアル番号",
        "serialNumber": "シリアル番号",
        "serialNumberAlreadyAssigned": "既に適用されたシリアル番号です",
        "select": "選択する",
        "selectAll": "全て選択する",
        "selectLanguage": "言語を選択する",
        "setup": "セットアップ",
        "settings": "設定",
        "shapeColors": "カラーを作成する",
        "shareWithText": "{productShortName} デジタルサイネージ。シンプル。スマート。パワフル。",
        "signIn": "サインイン",
        "signUp": "サインアップ",
        "signUpErrorMessageAccountEmailExist": "入力されたメールアドレスのアカウントが既に存在しています。",
        "slowSync": "スローシンク ",
        "sorry": "申し訳ありません。",
        "streetAndNumber": "市町村以下の住所と番地",
        "success": "成功",
        "summary": "サマリー",
        "somethingWentWrong": "問題が発生しました",
        "song": "ソング | ソング",
        "startDate": "スタートした日",
        "startTime": "始める",
        "start": "始める",
        "state": "州",
        "steps": "ステップ",
        "styleName": "スタイル名",
        "storage": "ストレージ",
        "subtotal": "小計",
        "subscription": "サブスクリプション",
        "subscriptionMonthlyAutoRenew": "月別（自動更新）",
        "ssoLoginErrorTitle": "問題が発生しました、現在サインインができません。時間をおいて再度試すか、管理者にお問い合わせください",
        "ssoMigrateAccountStep1Title1": "{email}のアカウントは既に存在しています。",
        "ssoMigrateAccountStep1Title2": "変更して{provider} SSOを使用することが可能です",
        "ssoMigrateAccountStep1Title3": "次に進んで変更を確定する",
        "ssoMigrateAccountStep2Title1": "{provider} SSOに変更すると、",
        "ssoMigrateAccountStep2Title2": "これまでのサインインが無効となります。",
        "ssoMigrateAccountStep2Title3": "変更を取り消すことはできません。",
        "ssoMigrateAccountVerifyTitle1": "現在のアカウント {email}の確認を行う必要があります。",
        "ssoMigrateAccountVerifyTitle2": "次に進むには、該当するアカウントでサインインしてください。",
        "tag": "タグ | タグ",
        "defaultTags": "デフォルトタグ",
        "text": "テキスト",
        "deleteAccountWithMultipleUsersMessage": "このアカウントの削除を行う前に、他のユーザー全てを消去する必要があります。",
        "deleteAccountWithDistributorRightsMessage": "アカウントが削除できません。アカウントはディストリビューターが所有しています。",
        "deleteAccountTitleThisActionWill": "これにより",
        "deleteAccountImplications": {
            "deleteAccount": "1.アカウントを削除します",
            "deleteUser": "2.ユーザーを削除します"
        },
        "youCannotDeleteUserAsOnlyUserInAccount": "アカウントにはあなた以外のユーザーがいないため、削除することができません。",
        "timeZone": "タイムゾーン",
        "time": "時間",
        "timeShorthandSecond": "秒",
        "timeShorthandMinute": "分",
        "timeShorthandHour": "時",
        "template": "テンプレート | テンプレート",
        "temporaryPassword": "ワンタイムパスワード",
        "tempPasswordExpiredPleaseContactAdmin": "ワンタイムパスワードが無効になりました。管理者にお問い合わせください",
        "total": "合計",
        "tutorial": "ガイド | ガイド",
        "user": "ユーザー | ユーザー",
        "userAPIKey": "APIキー",
        "userNotActive": "ユーザーがアクティブではありません",
        "usernameShouldBeValidEmail": "ユーザー名は有効なメールアドレスである必要があります。",
        "updatedAccountInfo": "アカウント情報がアップデートされました。",
        "updatedCustomerInfo": "カスタマー情報がアップデートされました。",
        "updatedProfile": "ユーザープロフィールがアップデートされました。",
        "updated": "アップデート済み",
        "upload": "アップロードする",
        "upTime": "アップタイム",
        "upgrade": "アップグレード",
        "video": "動画",
        "vat": "付加価値税",
        "verificationCode": "確認コード",
        "verticalView": "確認ビュー",
        "withResolution": "解像度 {resolution}",
        "yourPlan": "計画済みのプラン",
        "youHaveLeftAccount": "アカウントから退出しました",
        "zipOrPostalCode": "郵便番号",
        "mon": "月",
        "tue": "火",
        "wed": "水",
        "thu": "木",
        "fri": "金",
        "sat": "土",
        "sun": "日",
        "apps": "アプリ",
        "multiplePopIdsNotAllowed": "各ファイルにはプレイ証明書識別子が1つしかない可能性があります。",
        "forbidden": "問題が発生し、リクエストを完了することができませんでした。間もなくホーム画面へリダイレクトされます。",
        "dataStorageRegion": "データストレージ地域",
        "verificationSentToEmailIfExist": "確認コードがメールに送信されました（アカウントが存在する場合）",
        "alreadyHaveAnAccountRedirect": "すでにアカウントをお持ちですか？ {linkStart}ログイン{linkEnd}",
        "emailText": "メールアドレス",
        "passwordText": "パスワード",
        "signupWith": "登録する",
        "setNewPassword": "パスワードを設定する",
        "passwordHint": "{minStart}最低 8 文字,{minEnd} {upStart}大文字,{upEnd} {lowStart}小文字,{lowEnd} {numStart}数字と{numEnd} {spStart}特殊文字{spEnd}。",
        "home": "ホーム",
        "loginWithName": "{name}でログイン",
        "signupWithName": "{name}で登録",
        "fileType": "ファイルタイプ",
        "lastModified": "最終更新日",
        "images": "画像",
        "videos": "動画",
        "projectsOrPdf": "プロジェクト / PDF",
        "elementiProject": "Elementiプロジェクト",
        "scheduled": "スケジュール済み",
        "notScheduled": "未スケジュール",
        "from": "開始",
        "to": "終了",
        "fileTypes": "ファイルタイプ",
        "contentStatus": "コンテンツステータス",
        "modifiedDate": "変更日",
        "filters": "フィルター",
        "sortBy": "並び替え基準",
        "sort": "並び替え",
        "lastModifiedDesc": "最終更新日（新しい順）",
        "lastModifiedAsc": "最終更新日（古い順）",
        "nameAsc": "名前 (A → Z)",
        "nameDesc": "名前 (Z → A)",
        "grid": "グリッド",
        "canvas": "キャンバス",
        "audioPlaylist": "オーディオプレイリスト",
        "isAlertActive": "アラートが有効",
        "active": "有効",
        "inactive": "無効",
        "filesPage": "ファイルページ",
        "ledPage": "LEDページ",
        "videowallPage": "Videowallページ",
        "alertPage": "アラートページ"
    },
    "buttons": {
        "backToProduct": "{productName} に戻る",
        "reload": "再読み込み",
        "previous": "前へ",
        "next": "次へ",
        "loadMore": "さらに読み込む",
        "addNewUser": "新しいユーザーを追加",
        "apply": "適用",
        "clearAll": "すべてクリア",
        "reset": "リセット",
        "tryItNow": "今すぐ試す",
        "switchBack": "元に戻す",
        "cancel": "キャンセル",
        "deleteMedia": "メディアを削除",
        "deletePlayer": "プレーヤーを削除",
        "deleteTag": "タグを削除",
        "deletePopId": "PoP IDを削除",
        "deleteUser": "ユーザーを削除",
        "continueWithoutSaving": "保存せずに続ける",
        "close": "閉じる",
        "cancelOrder": "注文をキャンセル",
        "removeUser": "ユーザーを削除",
        "deleteTemplate": "テンプレートを削除",
        "deleteStyle": "スタイルを削除",
        "ok": "OK",
        "delete": "削除",
        "keepBoth": "両方保持",
        "replaceExistingFile": "既存ファイルを置き換える",
        "replaceExistingFiles": "既存ファイルを置き換える（複数）"
    },
    "texts": {
        "youAreLoggingIn": "以下を使用してログインしています",
        "productAccessDisabled": "{product}にアクセスできません",
        "productAccessDisabledWarning": "{account}アカウントの{product}にアクセスできません。\n\nこの製品へのアクセスが許可されていないか、グローバル管理者によってアクセスが取り消されました。詳細情報やアクセスをリクエストするには、グローバル管理者に連絡してください。\n\nこのアカウント内で使用する許可がある他の製品には引き続きアクセスできます。",
        "tablePageCountWTotal": "{min}{separator}{max} 件中 {total} 件を表示",
        "tablePageCountWoutTotal": "{min}{separator}{max} 件を表示",
        "dataStorageRegionHint": "アカウントデータを保存する地域を選択してください。この決定は、現地のデータ保護法およびコンプライアンス要件と一致している必要があります。注意：一度選択すると、データレジデンシー地域は後で変更することができません。",
        "welcomeToHUB": "SpinetiX HUBへようこそ！",
        "welcomeToHUBDesc": "SpinetiX HUBは、クラウド上でSpinetiXデジタルサイネージに関するすべてを管理するオールインワンのオンラインプラットフォームです。",
        "hubGlobalAdmin": "SpinetiXグローバル管理者",
        "hubGlobalAdminDesc": "このユーザーはHUBのグローバル管理者であり、ARYAで管理者の役割が自動的に付与されます。この役割の割り当ては変更できません。",
        "removeAccessFromAryaTitle": "ARYA へのアクセスを削除しますか？",
        "removeAccessFromAryaMessage": "これにより、{userName} の ARYA へのアクセスのみが削除されます。",
        "removeAccessFromAryaByNonGlobalAdmin": "ユーザーを HUB アカウントから削除するには、Global Admin に連絡してください。",
        "removeAccessFromAryaByGlobalAdmin": "このHUBアカウント内の他の製品へのアクセスは維持されます。\n\nHUBアカウントからユーザーを削除するには、{link}に移動してください",
        "hubUserManagement": "HUBユーザー管理",
        "goToHUBUserManagement": "HUB ユーザー管理に移動してください。",
        "noContentHasBeenScheduledYet": "まだコンテンツがスケジュールされていません。",
        "emptyFilterTablePlaceholder": "検索に一致するアイテムが見つかりませんでした。検索条件を調整して再試行してください！",
        "requestId": "リクエストID：",
        "externalSignInMessage": "外部のIDプロバイダー（例: Google、Facebook、または他のIDプロバイダーによるSSO）でサインインしています。{email} および {password} を含む認証情報は、そのプロバイダーによって管理されています。",
        "youHaveUnsavedChanges": "未保存の変更があります。",
        "waitForUploadingFile": "ファイルをアップロード中です。お待ちください...",
        "defaultTagsNote": "プロジェクトはテンプレートから作成される際、スタイルパックのタグを継承します。スタイルパックのタグを後から追加または削除しても、既存のプロジェクトは更新されません。",
        "seeAll": "すべて表示",
        "allPlayTimes": "すべての再生時間"
    },
    "switchedAccount": {
        "title": "アカウントが変更されました",
        "desc1": "おかえりなさい。",
        "switch": "変更する",
        "text1": "アカウントが変更されました",
        "text2": "{account}"
    },
    "unsupportedBrowser": {
        "bannerTitle": "ご使用のブラウザはサポートされていません",
        "bannerMessage": "サポートされていないブラウザが使用されています。特定の機能が適切に作動しない可能性があります。当社製品で最高の体験をお楽しみいただくため、{highlightStart}Google Chrome{highlightEnd}または{highlightStart}Microsoft Edge{highlightEnd}を使用してください。"
    },
    "plans": {
        "downgradedToFreeDesc": "{plan}プランが有効になりました。お支払いサイクル末の最後に1回、クレジットカードへのチャージが行われます。",
        "free": "無料",
        "tags": "スマートシンク＆タグ",
        "sharedStorage": "共有ストレージ",
        "custom": "カスタム＆アラート",
        "playerStorage": "プレイヤーのストレージ",
        "playerPerMonth": "プレイヤー/月 | プレイヤー/月",
        "review": {
            "termsAndConditionsMain": "注文を行った時点で、以下を承認したと見なされます",
            "termsAndConditionsSub": "SpinetiX 販売に関する利用規約"
        }
    },
    "filters": {
        "images": "画像",
        "videos": "動画",
        "audio": "オーディオ",
        "projectsOrPdf": "プロジェクト/PDF",
        "scheduled": "スケジュール済み",
        "elementiProject": "エレメンティプロジェクト"
    },
    "template": {
        "24H": "24時間",
        "AM/PM": "午前/午後",
        "addPage": "ページを追加する",
        "arrowSettings": "矢印の設定",
        "back": "前に戻る",
        "background": "背景",
        "both": "両方",
        "bottom": "下",
        "center": "中央",
        "cellSettings": "セルの設定",
        "clock": "時計",
        "clockSettings": "時計の設定",
        "countdown": "カウントダウン",
        "countdownSettings": "カウントダウンの設定",
        "custom": "カスタマイズする",
        "changeMedia": "メディアを変更する",
        "default": "デフォルト",
        "duplicatePage": "複製されたページ",
        "date": "日付",
        "days": "日",
        "effects": "効果",
        "fade": "フェード",
        "fill": "塗りつぶし",
        "front": "前面",
        "frameFitting": "フレームのフィッティング",
        "hours": "時",
        "imageEffects": "画像効果",
        "kenBurns": "ケン・バーンズ",
        "noEffect": "効果なし",
        "noBorder": "境界線なし",
        "noMargin": "余白なし",
        "L": "L",
        "large": "大",
        "left": "左",
        "local": "ローカル",
        "long": "長",
        "M": "M",
        "meet": "ミート",
        "media": "メディア",
        "menu": "メニュー",
        "mediatable": "メディア一覧表",
        "middle": "中央",
        "month": "月",
        "overlay": "オーバーレイ",
        "overview": "オーバービュー",
        "playOnce": "1回プレイする",
        "qr": "qr",
        "reg": "reg",
        "repeat": "リピートする",
        "right": "右",
        "rss": "RSS",
        "shape": "形",
        "shapeSettings": "形の設定",
        "shapeSettingsHint": "ヒント：タイピングしてテキストを追加する",
        "slice": "スライス",
        "slide": "スライド",
        "small": "小",
        "smart": "スマート",
        "S": "S",
        "time": "時間",
        "timeAndDate": "時間 ＋ 日付",
        "tableSettings": "一覧表の設定",
        "text": "テキスト",
        "textSettings": "テキストの設定",
        "top": "トップ",
        "wayfinding": "ウェイファインディング",
        "weather": "天気",
        "html": "ウェブページ",
        "url": "url",
        "videoin": "Video-In",
        "videoWidth": "動画の幅",
        "videoHeight": "動画の高さ",
        "videoSettings": "動画の設定",
        "frameRate": "フレーム比率",
        "frameWidth": "幅を選択する",
        "format": "フォーマット",
        "error": {
            "invalidLink": "無効なリンクです"
        },
        "placeholder": {
            "url": "URLを入力する"
        },
        "weatherIconSettings": "天気アイコンの設定",
        "weatherLocationSettings": "天気位置の設定",
        "weatherLocationSettingsHint": "ヒント：位置の名称を入力してください",
        "webpageSettings": "ウェブページの設定",
        "qrSettings": "QRコードの設定",
        "rssSettings": "RSSコードの設定",
        "rssSettingsTooltip": "{productName}が提供するRSSフィードは<b>third-party providers</b>によるものです。<br>最大限、ニーズにマッチする選択肢を幅広くご用意していますが、その水準やパフォーマンスレベルは全て第三者プロバイダに委ねられています。",
        "stream": "ストリーミングを行う",
        "list": "リスト"
    },
    "templates": {
        "duration": "期間",
        "pageDuration": "ページ期間",
        "timezone": "タイムゾーン",
        "tags": "タグ",
        "playtimes": "プレイ時間",
        "alignElements": "エレメントの整列を行う",
        "removeTemplateConfirmation": "スタイル \"{styleName}\" からこのテンプレートを削除してもよろしいですか？",
        "deleteStyleConfirmation": "スタイル \"{styleName}\" を削除してもよろしいですか？",
        "deleteStyleWarning": "このスタイルを削除すると、そこに作成されたすべてのテンプレートが削除されます。",
        "noTemplatesAvailable": "利用可能なテンプレートがありません",
        "noStylePackAccess": "現在、テンプレートを含むスタイルパックへのアクセス権がありません。スタイルパックは、割り当てられた権限またはタグを通じて共有された場合にのみ利用できます。\nアクセス権があるべきだと思われる場合は、アカウント管理者にお問い合わせください。"
    },
    "Hours": {
        "title": "タイトル",
        "time": "時間",
        "media": "メディア"
    },
    "Info": {
        "info": "情報",
        "title": "タイトル",
        "description": "テキスト",
        "media": "メディア"
    },
    "Logo": {
        "title": "テキスト"
    },
    "Menu": {
        "menu": "メニュー",
        "title": "テキスト",
        "price": "価格",
        "media": "メディア"
    },
    "News": {
        "news": "ニュース",
        "title": "テキスト",
        "timezone": "タイムゾーン",
        "format": "フォーマット",
        "media": "メディア"
    },
    "Person": {
        "person": "人",
        "title": "上部テキスト",
        "description": "下部テキスト",
        "media": "メディア"
    },
    "Product": {
        "product": "製品",
        "title": "テキスト",
        "price": "価格",
        "media": "メディア"
    },
    "RSS": {
        "rss-news": "RSSニュース",
        "rss": "RSS",
        "news": "ニュース"
    },
    "Weather": {
        "weather": "天気",
        "locations": "都市",
        "display": "ディスプレイ",
        "media": "メディア"
    },
    "playerSetup": {
        "navConfirm": "確定する",
        "navFinish": "終了する",
        "navNext": "次へ",
        "navPrev": "前に戻る",
        "navCancel": "キャンセルする",
        "addPlayerToPlan": "プレイヤーをプランに追加する",
        "currentPlan": "現在のプラン",
        "canvasName": "キャンバス名",
        "canvasVideoNote": "新しいキャンバスは、この名前で{canvasType}に保存されます。",
        "canvasVideoNoteType_led": "LEDセクション",
        "canvasVideoNoteType_videowall": "動画ウォールセクション",
        "canvasSize": "キャンバスサイズ",
        "canvasSizeFormatted": "{canvasSize}ピクセル",
        "updateTo": "アップデートする",
        "numberOfPlayers": "プレイヤーの数",
        "dialogTitle": "プレイヤーのセットアップ",
        "onlyDigitsRequired": "数字のみ入力してください",
        "serialNumberRequired": "シリアル番号を空欄にしないでください",
        "incorrectSerialNumber": "正しいシリアル番号を入力してください",
        "incorrectSerialNumberCharacters": "有効な入力値を入力してください。このフィールドにはアルファベットと数字のみ入力可能です",
        "incorrectInput": "入力値に誤りがあります",
        "playerName": "名前",
        "playerNamePlaceholder": "プレイヤー名",
        "requiredPlayerName": "プレイヤー名が必要です",
        "requiredScreenDiagonal": "対角スクリーンが必要です",
        "requiredHorizontalBezel": "横ベゼル/ギャップが必要です",
        "requiredVerticalBezel": "縦ベゼル/ギャップが必要です",
        "playerTimezoneHint": "プレイヤーのタイムゾーンを選択してください",
        "Progress_PIN": "PIN",
        "Progress_Name": "名前＆タイムゾーン",
        "Progress_DisplaySettings": "ディスプレイの設定",
        "Progress_Application": "アプリケーション",
        "Progress_Arrangement": "アレンジ",
        "Progress_Adjustments": "調整",
        "DisplayOrientation": "ディスプレイの向き",
        "DisplayResolution": "ディスプレイの解像度",
        "DisplayResolutionHint": "ディスプレイの解像度を選択してください",
        "Application": "アプリケーション",
        "ApplicationSingleDisplay": "シングルディスプレイ",
        "ApplicationMirroring": "ミラーリング",
        "ApplicationVideowall": "画像ウォール",
        "ApplicationAvailable": "* 利用可能です",
        "ApplicationAvailbleWithNote": "*利用可能です",
        "screenDiagonal": "対角スクリーン",
        "SelectApplication": "アプリケーションを選択する",
        "SelectDisplayOrientation": "ディスプレイの向きを選択する",
        "SelectNumberOfDisplays": "ディスプレイの数を選択する",
        "standardScreenOnly": "標準スクリーンのみ（9:16、16:9）",
        "OrientationAndResolution": "ディスプレイの向きと解像度は、全てのディスプレイに適用されます",
        "DisplaysArrangement": "ディスプレイのアレンジ",
        "SelectDisplayArrangement": "ディスプレイのアレンジを選択する",
        "HorizontalBezel": "横ベゼル/ギャップ",
        "VerticalBezel": "縦ベゼル/ギャップ",
        "OutputResolutions": "出力解像度",
        "CannotCreateLEDTag": "LED解像度が作成できません",
        "CannotCreateVideowallTag": "画像ウォールキャンバスが作成できません",
        "UnknownError": "問題が発生しました。再度試すか、サポートセンターにお問い合わせください。",
        "InvalidAdjustmentsForm": "入力の承認エラーが出ました、全てのフィールドに正しく入力してください",
        "CanvasDimensionsError": "キャンバスの幅と高さが適切に作成されませんでした",
        "playerDeleteConfirmation": "プレーヤー「{playerName}」を削除してもよろしいですか？",
        "playerDeleteWarning": "プレーヤーを削除すると、SpinetiX HUBアカウントから削除され、スケジューリングを含むすべての関連設定も削除されます。"
    },
    "planCard": {
        "getPremium": "プレミアム版を入手する",
        "bestforGettingStarted": "スタートに最適",
        "discovery": "ディスカバリー",
        "free": "無料",
        "oneUser": "1ユーザー",
        "oneGBStorage": "1GBのストレージ",
        "nineTemplates": "9つのテンプレート",
        "yourPlan": "プラン",
        "elevateYourDigitalSignage": "デジタルサイネージをレベルアップする",
        "premium": "プレミアム",
        "premiumPlanPrice": "21 スイスフラン",
        "playerPerMonth": "プレイヤー / 月",
        "tenUsersAndRoles": "10 ユーザー＆ユーザーロール",
        "tenGBPlayerStorage": "10GB / プレイヤーのストレージ",
        "twelveTemplatesCustomizable": "12のテンプレート / カスタマイズ可能",
        "twelveApps": "Webpageを含む12のアプリを含みます",
        "elevenApps": "11のアプリ",
        "assetGrouping": "資産グルーピング",
        "scheduleAutomation": "スケジュールのオートメーション化",
        "priorityScheduling": "優先スケジューリング",
        "alerts": "アラート",
        "audio": "オーディオ",
        "videoWallSupport": "動画ウォールサポート*",
        "new": "新機能！",
        "withTheNew": "*新"
    },
    "planUpgrade": {
        "errorFetchingInvoice": "エラー取り込み式インボイス。再度試してください。",
        "close": "閉じる",
        "getPremium": "プレミアム盤を入手する！",
        "companyName": "企業名",
        "dialogTitle": "アップグレードを計画する",
        "navConfirm": "確定する",
        "navFinish": "終了する",
        "navNext": "次へ",
        "navPrev": "前に戻る",
        "navCancel": "キャンセルする",
        "VATNumber": "付加価値税登録番号",
        "Overview": "オーバービュー",
        "AccountOwner": "アカウント所有者",
        "CompanyInfo": "企業情報",
        "BillingDetails": "お支払い明細",
        "Payment": "お支払い",
        "tryAgain": "再度試す",
        "paymentSuccessful": "お支払いが正しく行われました",
        "welcomeToPremium": "プレミアム版へようこそ！",
        "paymentFailed": "お支払いに問題がありました。",
        "selectCountry": "国を選択する",
        "selectState": "州を選択する"
    },
    "licenseOrdering": {
        "yourOrders": "注文",
        "cancelOrder": "注文をキャンセルする",
        "orderNumber": "注文番号",
        "orderDate": "注文日",
        "comment1": "コメント1",
        "comment2": "コメント2",
        "close": "閉じる",
        "cancelOrderWarning": "注文を本当にキャンセルしますか？",
        "noOrdersAvailable": "まだ注文されていません",
        "noRecordsFound": "\"{query}\"の検索ワードに合うものが見つかりませんでした",
        "noRecordsFoundNote1": "検索内容にミスタイピングまたは間違いがないか、確認してください",
        "noRecordsFoundNote2": "別の検索ワードを使用してみてください"
    },
    "fileUpload": {
        "notAllowedToUploadMedia": "メディア上でのアップデートが認められていないユーザーです",
        "hashMD5ComputationError": "hashMD5の計算中にエラーが発生しました。",
        "duplicateFileUploadErrorTitle": "この名前のファイルはすでに存在します",
        "multipleDuplicateFileUploadErrorTitle": "これらの名前のファイルはすでに存在します",
        "duplicateFileUploadErrorDescription": "\"{mediaName}\"という名前のファイルは、すでにライブラリに存在します。",
        "multipleDuplicateFileUploadErrorDescription": "\"{mediaNames}\"という名前のファイルは、すでにライブラリに存在します。",
        "duplicateFileUploadErrorMessage": "既存のファイルを確認し、新しいアップロードをどうするか選択してください。\n{pleaseNote}: 既存のファイルを置き換える場合は、アップロード完了後にページを再読み込みして更新版を表示してください。",
        "duplicateFileUploadPreviewTitle": "既存のファイル",
        "pleaseNote": "ご注意"
    },
    "downloadLicense": {
        "confirmDownloadLicense": "よろしいですか？この方法はインターネットに接続されないプレーヤー専用です。",
        "confirmDownloadLicenseWarning": "この方法を使用すると、変更の猶予期間なしにライセンスがシリアル番号に即座に関連付けられます。"
    },
    "activation": {
        "assign": "適用する",
        "yourLicenses": "ライセンス",
        "comment": "コメント",
        "playerSerialNumber": "プレイヤーのシリアル番号",
        "licenseCode": "ライセンスコード",
        "activationDate": "アクティブ化した日付",
        "license": "ライセンス",
        "suspend": "保留にする",
        "restore": "元に戻す",
        "download": "ダウンロードする",
        "licenseAvailable": "利用可能なライセンス ",
        "licenseLockedToAPlayer": "ライセンスがプレイヤーにロックされています",
        "playerSerialNumberRequired": "プレイヤーのシリアル番号コードが必要です",
        "licenseCodeRequired": "ライセンスコードが必要です",
        "processing": "処理中",
        "waitingForPlayerToConnect": "プレイヤーへの接続待機中",
        "noLicensesAvailable": "ライセンスは追加されていません"
    },
    "resolutionCalculator": {
        "invalidPitch": "ピッチに誤りがあります",
        "invalidSize": "サイズに誤りがあります"
    },
    "legal": {
        "legal": "法的",
        "endUserLicenseAgreement": "エンドユーザー ライセンス承認",
        "generalTermsAndConditionsOfSale": "一般利用規約",
        "termsOfService": "サービス規約",
        "privacyPolicy": "プライバシーポリシー",
        "cookieNotice": "クッキー通知",
        "downloadPDF": "PDFをダウンロードする"
    },
    "accountSuspended": {
        "bannerTitle": "サブスクリプションの有効期限が切れました！",
        "bannerMessage": "更新をご希望の場合は、再販業者にお問い合わせください。"
    },
    "errors": {
        "invalid": {
            "verificationCode": "提供された確認コードが無効です。もう一度お試しください。",
            "passwordReset": "パスワードをリセットできません。",
            "provider": "無効なプロバイダーです。もう一度お試しください。",
            "emailMismatch": "入力したメールアドレスは、移行しようとしているアカウントと一致しません。"
        },
        "existing": {
            "userAlreadyLinked": "ユーザーはすでに別のIDプロバイダー（IdP）にリンクされています。",
            "accountInAnotherRegion": "ユーザーはすでに別のリージョンにアカウントを持っています"
        },
        "failedRefreshToken": "ログアウトされました。続行するには再度ログインしてください。",
        "cannotMigrateAccountInAnotherRegion": "SSO に移行できません。メールアドレスが、移行しようとしているアカウントとは異なるデータ保存リージョンに関連付けられています。",
        "nonSSOAuthDenied": "非SSOプロバイダーを使用した認証は許可されていません。",
        "ssoMigrationFailed": "アクセスが拒否されました：アカウントがすでに別のIDプロバイダー（IdP）にリンクされているため、SSOに切り替えることはできません。詳細は管理者にお問い合わせください。",
        "loginUnexpectedError": "予期しないエラーによりログインに失敗しました。もう一度お試しください。",
        "unexpectedError": "予期しないエラーが発生しました。ページを再読み込みしてください。",
        "somethingWentWrong": "問題が発生したようです ({errorCode})",
        "somethingWentWrongDescription": "このページの読み込み中にエラーが発生しました。<br><br><strong>対処方法：</strong><br>ページを更新して再試行してください。<br>それでも読み込まれない場合は、サポートに連絡し、以下のリクエストIDを共有してください。",
        "failedToUpdateAccountInfo": "アカウント情報の更新に失敗しました。",
        "failedToFetchLicenses": "ライセンスの取得に失敗しました。",
        "failedToDownloadLicense": "ライセンスのダウンロードに失敗しました。",
        "failedToDownloadFile": "ファイルのダウンロードに失敗しました。",
        "failedToFetchUserInfo": "ユーザー情報の取得に失敗しました",
        "failedToFetchPlaces": "場所の取得に失敗しました",
        "fileNotSupported": "このファイル形式はサポートされていません。"
    },
    "regionNames": {
        "eu": "欧州連合 / European Union",
        "ch": "スイス / Switzerland",
        "us": "アメリカ合衆国 / United States",
        "ca": "カナダ / Canada",
        "au": "オーストラリア / Australia",
        "hk": "香港 / Hong Kong",
        "sg": "シンガポール / Singapore"
    },
    "zendesk": {
        "chatCouldNotBeLoaded": "チャットを読み込めませんでした",
        "chatCouldNotBeLoadedDescription": "サポートチャットを読み込むことができませんでした。これは通常、ブラウザのプライバシー設定またはクッキー設定が原因です。サポートチャットを有効にする方法については、こちらをクリックしてください：{url}。"
    },
    "media": {
        "mediaUploadSuccessTitle": "メディアを準備しています…",
        "mediaUploadSuccessMessage": "有効なフィルターまたは並べ替えにより、現在のビューに表示されない場合があります。",
        "mediaViewLegacyToV2Title": "リニューアルされたメディアページ",
        "mediaViewV2ToLegacyTitle": "新しいデザインをご利用中です！",
        "mediaViewSwitcherDescription": "高速なナビゲーション、フィルター、並べ替え。",
        "mediaDeleteConfirmation": "メディア \"{mediaName}\" を削除してもよろしいですか？",
        "multipleMediaDeleteConfirmation": "選択した{mediaCount}個のメディアを削除してもよろしいですか？",
        "mediaDeleteWarning": "このメディアを削除すると、すべてのプロジェクトからも削除されます。",
        "multipleMediaDeleteWarning": "これらのメディアを削除すると、使用しているすべてのプロジェクトからも削除されます。",
        "mediaFileUploadInfoMessage": "現在のビューに表示されていない場合、アクティブなフィルターまたはソートによって非表示になっている可能性があります。",
        "mediaIsReady": "メディアの準備ができました!",
        "mediaIsReadyWithCount": "メディアの準備ができました! ({count} / {total})",
        "someFilesUploadError": "一部のファイルを処理できませんでした",
        "failedUploadError": "ファイルを処理できませんでした。もう一度アップロードしてみてください。",
        "failedUploadErrorTitle": "メディアを処理できませんでした"
    },
    "leaveAccount": {
        "leaveAccountConfirmation": "アカウント [{accountName}] を退会してもよろしいですか？",
        "leaveAccountWarning": "このアカウントを退会すると、アカウントおよび現在利用可能なすべての関連製品・サービスへのアクセスを失います。"
    },
    "led": {
        "deleteCanvasConfirmation": "よろしいですか？このアクションはすべてのプレーヤーからこのキャンバス解像度を削除します。",
        "deleteCanvasWarning": "このキャンバス解像度を使用していたプレーヤーは、同じ解像度のコンテンツを再び公開する前に再設定が必要になります。"
    },
    "popId": {
        "deletePopIdConfirmation": "よろしいですか？このアクションはこのPoP IDが使用されているすべての場所から削除します。"
    },
    "tag": {
        "deleteTagConfirmation": "よろしいですか？この操作により、すべての{source}からこのタグが削除されます。",
        "deleteTagWarning": "これはユーザー権限とスケジュールに影響する可能性があります。"
    },
    "userProfile": {
        "permanent": "永続的",
        "deleteUserConfirmation": "ユーザープロフィールを削除しようとしています。このアクションは{permanent}であり、取り消すことができません。",
        "lose": "失う",
        "deleteUserWarning": "ユーザー認証情報に関連するすべてのアカウントおよび製品へのアクセスを{lose}ことになります。\n続行してもよろしいですか?"
    }
}
